import { api } from '../../helpers/api';

export default {
  async setOnboardingProperty({ commit, state }, { deviceType, property, value }) {
    const currentOnboardingState = {
      onboardingMobile: { ...state.onboardingMobile },
      onboardingDesktop: { ...state.onboardingDesktop },
    };

    currentOnboardingState[`onboarding${deviceType.charAt(0).toUpperCase() + deviceType.slice(1)}`][property] = value;


    try {
      const response = await api.post('parent/me/onboarding', currentOnboardingState);

      if (response && response.status === 200) {
        const mutationName = `setOnboarding${deviceType.charAt(0).toUpperCase() + deviceType.slice(1)}${
          property.charAt(0).toUpperCase() + property.slice(1)
        }`;

        commit(mutationName, value);
      } else {
        console.error('Failed to update onboarding property:', response);
      }
    } catch (error) {
      console.error('Error during API call:', error);
    }
  },
};
